type User = {
  account_id: number;
  userrole: string;
  user_id: number;
  email: string;
  password: string;
};

export type AuthState = {
  isAuthenticated: boolean;
  profile: User | null;
};

export const authInitialState: AuthState = {
  isAuthenticated: false,
  profile: null,
};
